// ============================================================
// ownBillWrites.ts — ★ echo suppression for "bill-changed" live events, per TAB.
//
// The server tells every allowed socket (the actor included) when a bill
// changes (lib/presence emitBillChanged). The tab that MADE the change
// already has the fresh bill from its own REST response, so re-fetching the
// whole bill on its own echo was pure waste (a second full load right after
// every save / format switch). But the actor's OTHER tabs do need the event —
// so, unlike entity-changed (dropped for the actor everywhere), this filter is
// scoped to the tab: casevoApi's response interceptor records each bill this
// tab just wrote, and services/presence drops a bill-changed event from the
// local user for one of those bills within ECHO_WINDOW_MS. Everyone else —
// other users, and this user's other tabs — still gets the live refresh.
// ============================================================
const ECHO_WINDOW_MS = 5000
const recent = new Map<string, number>()

export const markOwnBillWrite = (billId: string): void => {
  const now = Date.now()
  recent.set(billId, now)
  // Keep the map tiny: forget anything outside the window.
  recent.forEach((at, id) => { if (now - at > ECHO_WINDOW_MS) recent.delete(id) })
}

export const isOwnBillEcho = (billId: string): boolean => {
  const at = recent.get(billId)
  return at !== undefined && Date.now() - at <= ECHO_WINDOW_MS
}
